import React, { Fragment } from 'react'

import SearchForm from '../../search/form'
import SearchResults from '../../search/results'
import Banner from '../../banner'

export default () => (
  <Fragment>
    <div>
      <SearchForm searchType="cargo" />
    </div>
    <div className="banner-row" id="bannerRow">
      <Banner bannerId={526} />
      <div className="mobile-banner-on">
        <Banner bannerId={527} />
      </div>
    </div>
    <div className="row row-right">
      <div className="col-md-16">
        <SearchResults
          searchType="cargo"
          bannerId={528}
          showDateIsShort
          needToShowAdsNearPagination
        />
      </div>
    </div>
  </Fragment>
)
